import { useEffect, useState } from "react";
import { Form } from "react-bootstrap";
import { PreTask } from "../../interfaces/Task";
import CustomEditor from "../../elements/CustomEditor";
import Help from "../../elements/HelpContent";
import { registerEventEnd, registerEventStart } from "../../../utils/utils";
import AITools from "../../elements/AITools";
import { useTranslation } from "react-i18next";
import { Overlay } from "../../elements/Overlay";

const emptyPreTask: any = {
    _id: '0',
    name: '',
    updated:new Date(),
    type: 'text',
    instructions: '',
    text: ''
}

export interface NewPreTaskTextProps {
    saveForm: CallableFunction;
    closeForm: CallableFunction;
    task_language?: string;
}

export default function NewPreTaskText(props: NewPreTaskTextProps) {
    const { t } = useTranslation();
    
    const [eventId, setEventId] = useState('');
    const [preTask, setPreTask] = useState<PreTask>(emptyPreTask);
    const [name, setName] = useState('');
    const [instructions, setInstructions] = useState('');
    const [teacher_notes, setTeacherNotes] = useState('');
    const [text, setText] = useState('');

    const handleNameChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        setName(e.target.value);
    }

    const handleInstructionsChange = (data: string) => {
        setInstructions(data);
    }

    const handleTeacherNotesChange = (data: string) => {
        setTeacherNotes(data);
    }

    const handleTextChange = (data: string) => {
        setText(data);
    }

    const close = () => {
        registerEventEnd(eventId);
        props.closeForm();
    }

    const save = () => {
        if (!name) {
            return;
        }
        registerEventEnd(eventId);
        preTask.name = name;
        preTask.instructions = instructions;
        preTask.teacher_notes = teacher_notes;
        preTask.text = text;
        props.saveForm(preTask);
    }

    useEffect(() => {
        registerEventStart('new pretask text', '').then(data => {
            setEventId(data);
        });
    }, []);

    useEffect(() => {
        return () => {
            if (eventId) {
                registerEventEnd(eventId);
            }
        };
    }, [eventId]);

    const doNothing = () => {
        
    }

    return(
        <Overlay title={t("New Pre-Task: Text")} onClose={close} actions={[
            {
                label: t("Cancel"),
                variant: 'secondary',
                onClick: close
            },
            {
                label: t("Save"),
                variant: 'primary',
                onClick: save
            }
        ]}>
            <div className="new-task-container">
                <div className="inner">
                    <h2>
                        { t("New Pre-Task: Text") }
                        <Help id={ '6520147a1e5cf99991b4e371' } />
                    </h2>
                    <AITools />
                    <Form className="new-pre-task-form">
                        <div className="fields-container">
                            <Form.Group className="field field-title">
                                <Form.Label>{ t("Title of the Pre-Task") }</Form.Label>
                                <Form.Control type="text" name="name" required value={ name } onChange={ handleNameChange } />
                            </Form.Group>
                            <div className="field field-instructions">
                                <CustomEditor
                                    change={ handleInstructionsChange }
                                    changeFormatted={ doNothing }
                                    data={ '' }
                                    formatted= { '' }
                                    id="instructions"
                                    label={ t("Aim and instructions") }
                                    npl={ false }
                                    task_id={ '' }
                                    task_language={ props.task_language }
                                />
                            </div>
                            <div className="field field-teachernotes">
                                <CustomEditor
                                    change={ handleTeacherNotesChange }
                                    changeFormatted={ doNothing }
                                    data={ '' }
                                    formatted= { '' }
                                    id="teachernotes"
                                    label={ t("Teacher notes") }
                                    npl={ false }
                                    task_id={ '' }
                                />
                            </div>
                            <div className="field field-text">
                                <CustomEditor
                                    change={ handleTextChange }
                                    changeFormatted={ doNothing }
                                    data={ '' }
                                    formatted= { '' }
                                    id="text"
                                    label={ t("Text")}
                                    npl={ false }
                                    task_id={ '' }
                                    task_language={ props.task_language }
                                />
                            </div>
                        </div>
                    </Form>
                </div>
            </div>
        </Overlay>
    );
}